var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tile-basic',{staticClass:"is-info",attrs:{"values":_vm.keyValues(_vm.pkg),"title":_vm.title,"img":"pkg","headerImg":"pkg"}})}
var staticRenderFns = []

export { render, staticRenderFns }